// Set just before each route renders, so the incoming page can see where the reader came from.
let previousPath = null;

export const recordPreviousPath = prevLocation => {
  previousPath = prevLocation ? prevLocation.pathname : null;
};

export const getPreviousPath = () => previousPath;
